import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import {
  headerBg,
  logo,
  logoTitle,
  mobileLogo,
  viewMenu,
  sushiCoMenu,
} from 'images'
import ViewMenu from './ViewMenu'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          bg="rgb(0,0,0,.8)"
          style={{
            backdropFilter: 'blur(10px)',
            webkitBackdropFilter: 'blur(10px)',
          }}
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
        >
          <CFImage mt="10px" w="95%" src={logo} alt="SushiCo Logo Title" />
          <CFView hover mb="-5px">
            <ViewMenu />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          w="100%"
          h="60px"
          bg="rgb(0,0,0,.8)"
          style={{
            backdropFilter: 'blur(10px)',
            webkitBackdropFilter: 'blur(10px)',
          }}
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          zIndex={98}
        >
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFView row center mb="2px">
              <CFImage
                h="55px"
                ml="65px"
                src={logo}
                alt="SushiCo Korean Logo Title"
              />
            </CFView>
            <CFView hover mt="10px" mr="25px">
              <ViewMenu />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
